<template>
  <native-board v-if="ready && !error && allowed" :active="routeActive" />
  <section v-else class="rx-native-access">
    <p v-if="!ready" role="status">이용 정보를 확인하고 있습니다.</p>
    <template v-else>
      <h1>지역과 경제를 연결하는 통합 차트</h1>
      <p v-if="error" role="alert">이용 정보를 확인하지 못했습니다. 잠시 후 다시 시도해 주세요.</p>
      <p v-else>기존 익스퍼트 일반 등급 이상 회원에게 제공됩니다.</p>
      <button v-if="error" class="rx-button rx-button-blue" @click="checkAccess">다시 확인</button>
      <router-link v-else class="rx-button rx-button-blue" :to="$store.state.isLoggedin ? '/pricing' : '/login'">{{ $store.state.isLoggedin ? '이용권 확인하기' : '로그인하고 분석하기' }}</router-link>
      <router-link to="/realestate">전체 분석 둘러보기 →</router-link>
    </template>
  </section>
</template>
<script>
import NativeBoard from './NativeBoard.vue';
import { setPresentation } from '../presentation';
export default {
  name: 'NativeEntry',
  components: { NativeBoard },
  data: () => ({ ready: false, error: false, routeActive: true }),
  computed: {
    allowed() { return this.$store.state.isLoggedin && this.$store.state.authorityLevel >= 100; }
  },
  created() { setPresentation(true); this.checkAccess(); },
  activated() { this.routeActive=true;setPresentation(true); },
  deactivated() { this.routeActive=false; },
  methods: {
    async checkAccess() {
      this.ready = false;
      this.error = false;
      try { await this.$store.dispatch('updateLoggedin'); }
      catch (_) { this.error = true; }
      finally { this.ready = true; }
    }
  }
};
</script>
